import React from "react";
import Modal from "./Modal";

const FilterModal = ({
    isOpen,
    onClose,
    filterName,
    setFilterName,
    filterPhone,
    setFilterPhone,
    filterRating,
    setFilterRating,
    onClear,
    onApply,
}) => {
    if (!isOpen) return null;

    return (
        <Modal onClose={onClose}>
            <div className="filter-modal">
                <h2 className="filter-modal-title">Filter Customers</h2>

                <div className="filter-modal-group">
                    <label>Name</label>
                    <input
                        type="text"
                        className="filter-modal-input"
                        placeholder="Customer Name"
                        value={filterName}
                        onChange={(e) => setFilterName(e.target.value)}
                    />
                </div>

                <div className="filter-modal-group">
                    <label>Phone Number</label>
                    <input
                        type="text"
                        className="filter-modal-input"
                        placeholder="Phone Number"
                        value={filterPhone}
                        onChange={(e) => setFilterPhone(e.target.value)}
                    />
                </div>

                <div className="filter-modal-group">
                    <label>Rating</label>
                    <select
                        className="filter-modal-input"
                        value={filterRating}
                        onChange={(e) => setFilterRating(e.target.value)}
                    >
                        <option value="">All Ratings</option>
                        <option value="5 Star">5 Star</option>
                        <option value="4 Star">4 Star</option>
                        <option value="3 Star or Less">3 Star or Less</option>
                    </select>
                </div>

                <div className="filter-modal-actions">
                    <button onClick={onClear} className="filter-modal-button clear">
                        Clear Filters
                    </button>
                    <button onClick={onApply} className="filter-modal-button apply">
                        Apply Filters
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default FilterModal;
